import { render, staticRenderFns } from "./DeviceInformation.vue?vue&type=template&id=12113a65&scoped=true&"
import script from "./DeviceInformation.vue?vue&type=script&lang=js&"
export * from "./DeviceInformation.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInformation.vue?vue&type=style&index=0&id=12113a65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12113a65",
  null
  
)

export default component.exports